// Media gallery per produk.
// Setiap item: { type: "image" | "video", src, poster? }
// Untuk menambah foto/video sendiri: taruh file di /public/media/ lalu tulis
// src: "/media/nama-file.jpg" atau { type: "video", src: "/media/klip.mp4", poster: "/media/klip.jpg" }.
const u = (id) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400`;

const img = (id) => ({ type: "image", src: u(id) });

export const products = [
  {
    id: "hmpk-royal-orange",
    name: "HMPK Royal Electric Orange",
    strain: "HMPK",
    category: "Plakat",
    price: 1250000,
    media: [img("photo-1495594059084-33752639b9c3"), img("photo-1610906745360-921a9e9f2215")],
    specs: { size: "4,5 cm", ageMonths: 4, sex: "M" },
    desc: {
      id: "Halfmoon Plakat dengan warna oranye elektrik solid dari kepala hingga ujung sirip. Bukaan ekor 180° penuh, body tebal dan mental agresif khas plakat kontes.",
      en: "Halfmoon Plakat with solid electric orange from head to fin tips. Full 180° tail spread, thick body and the aggressive temperament of a show-grade plakat.",
    },
  },
  {
    id: "halfmoon-cyan-nebula",
    name: "Halfmoon Cyan Nebula",
    strain: "Halfmoon",
    category: "Halfmoon",
    price: 1850000,
    media: [img("photo-1534575180408-b7d7c0136ee8"), img("photo-1699425155230-fb6588e1ad5b")],
    specs: { size: "5 cm", ageMonths: 5, sex: "M" },
    desc: {
      id: "Halfmoon biru cyan metalik dengan gradasi nebula pada sirip. Sirip lebar, simetris, dan rapi — favorit kolektor untuk display tank.",
      en: "Metallic cyan Halfmoon with nebula-like gradients across the fins. Wide, symmetrical, immaculate finnage — a collector favourite for display tanks.",
    },
  },
  {
    id: "crowntail-crimson-flame",
    name: "Crowntail Crimson Flame",
    strain: "Crowntail",
    category: "Crowntail",
    price: 950000,
    media: [img("photo-1544943910-4c1dc44aab44"), img("photo-1548262323-694280fdc967")],
    specs: { size: "4,5 cm", ageMonths: 4, sex: "M" },
    desc: {
      id: "Crowntail merah menyala dengan ray sirip panjang menyerupai kobaran api. Warna merah pekat merata tanpa noda, cocok untuk pemula maupun kolektor.",
      en: "Blazing red Crowntail with long fin rays resembling flames. Deep, even red with zero wash — great for beginners and collectors alike.",
    },
  },
  {
    id: "giant-black-samurai",
    name: "Giant Black Samurai",
    strain: "Giant",
    category: "Giant",
    price: 2200000,
    stock: "sold",
    media: [img("photo-1543145334-8be4a6b8fc7f"), img("photo-1553986187-00635180f7c9")],
    specs: { size: "7 cm", ageMonths: 6, sex: "M" },
    desc: {
      id: "Giant berbodi besar dengan warna hitam samurai berkilau dan aksen merah pada sirip. Postur gagah, pergerakan tenang namun berwibawa.",
      en: "Large-bodied Giant in glossy samurai black with red accents on the fins. Imposing posture with calm, commanding movement.",
    },
  },
  {
    id: "dumbo-ear-lavender",
    name: "Dumbo Ear Lavender Dream",
    strain: "Dumbo Ear",
    category: "Plakat",
    price: 1400000,
    media: [img("photo-1562773765-4532ec42f13b"), img("photo-1534043464124-3be32fe000c9")],
    specs: { size: "4,5 cm", ageMonths: 4, sex: "M" },
    desc: {
      id: "Dumbo Ear dengan sirip dada ekstra lebar seperti telinga gajah, dibalut warna lavender pastel dan putih. Lembut, unik, dan sangat fotogenik.",
      en: "Dumbo Ear with extra-wide elephant-ear pectorals, dressed in pastel lavender and white. Soft, unique and extremely photogenic.",
    },
  },
  {
    id: "bonsai-copper-gold",
    name: "Bonsai Shortbody Copper Gold",
    strain: "Bonsai",
    category: "Plakat",
    price: 1650000,
    stock: "sold",
    media: [img("photo-1619491202102-088c4afb271c"), img("photo-1616261855171-2fa9baff476e")],
    specs: { size: "3,5 cm", ageMonths: 5, sex: "M" },
    desc: {
      id: "Bonsai shortbody dengan proporsi tubuh pendek-padat dan warna copper gold metalik yang berkilau di bawah cahaya. Langka dan sangat diminati.",
      en: "Compact shortbody Bonsai with metallic copper-gold scales that shimmer under light. Rare and highly sought after.",
    },
  },
  {
    id: "alien-emerald-hybrid",
    name: "Alien Wild Hybrid Emerald",
    strain: "Alien",
    category: "Plakat",
    price: 2500000,
    media: [img("photo-1573472420143-0c68f179bdc7"), img("photo-1699425155230-fb6588e1ad5b")],
    specs: { size: "5 cm", ageMonths: 6, sex: "M" },
    desc: {
      id: "Alien hybrid hasil persilangan betta liar dengan sisik emerald metalik bercorak. Karakter liar, lincah, dan warna yang berubah mengikuti cahaya.",
      en: "Wild-type Alien hybrid with patterned metallic emerald scales. Wild character, highly active, with colour that shifts with the light.",
    },
  },
  {
    id: "shortbody-red-galaxy",
    name: "Shortbody Red Galaxy Koi",
    strain: "Shortbody",
    category: "Plakat",
    price: 1750000,
    media: [img("photo-1538719501547-bc023056a8b6"), img("photo-1578507065211-1c4e99a5fd24")],
    specs: { size: "4 cm", ageMonths: 5, sex: "M" },
    desc: {
      id: "Koi galaxy dengan pola merah-biru acak bertabur sisik metalik seperti galaksi. Shortbody padat dengan sirip lebar yang mengembang sempurna.",
      en: "Galaxy koi with random red-blue patterning dusted in metallic scales like a galaxy. Dense shortbody with perfectly flared fins.",
    },
  },
  {
    id: "halfmoon-rosetail-sunset",
    name: "Halfmoon Rosetail Sunset",
    strain: "Halfmoon",
    category: "Halfmoon",
    price: 2100000,
    media: [img("photo-1534043464124-3be32fe000c9"), img("photo-1578507065211-1c4e99a5fd24")],
    specs: { size: "5 cm", ageMonths: 5, sex: "M" },
    desc: {
      id: "Rosetail dengan percabangan sirip ekstrem menyerupai kelopak mawar, gradasi merah-ungu-biru bak langit senja. Mewah dan dramatis.",
      en: "Rosetail with extreme fin branching like rose petals, graded red-violet-blue like a sunset sky. Lavish and dramatic.",
    },
  },
].map((p) => ({ stock: "available", ...p, image: p.media[0].src }));

export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(n);

export const heroImage = u("photo-1538719501547-bc023056a8b6");

export const storeAmbienceImage =
  "https://images.unsplash.com/photo-1764175760902-9cf284d444de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBkYXJrJTIwYXF1YXJpdW0lMjBzdG9yZSUyMGxpZ2h0aW5nJTIwZmlzaCUyMHRhbmslMjBhdG1vc3BoZXJlfGVufDB8fHx8MTc5MTU0NDExNXww&ixlib=rb-4.1.0&q=85";
